import updateItemIntent from "./updateItemIntent";
import updateItemVariantId from "./updateItemVariantId";
import getIndicativeVariantId from "./getIndicativeVariantId";
import { getIsOptedIn } from "../../../backInStock/selectors";
import isBackInStockNotificationEnabled from "../../../backInStock/isBackInStockEnabled";

const updateSavedItem = async (dispatch, item, getState) => {
  const {
    id,
    isOneSize,
    isNoSize,
    selectedColourWayId,
    selectedVariantId,
    variants
  } = item;
  const indicativeVariantId = getIndicativeVariantId({
    isOneSize,
    isNoSize,
    selectedColourWayId,
    selectedVariantId,
    variants
  });

  if (!indicativeVariantId) {
    dispatch(updateItemIntent(item));

    return;
  }

  const args = [item];
  if (isBackInStockNotificationEnabled()) {
    const isOptedInToBackInStockNotifications = getIsOptedIn(
      getState(),
      indicativeVariantId
    );
    args.push({ isOptedInToBackInStockNotifications });
  }

  dispatch(updateItemIntent(...args));

  return await updateItemVariantId(dispatch, id, indicativeVariantId);
};

export default updateSavedItem;
